import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Container, Card, Alert, Button, Row, Col } from 'react-bootstrap';
import { authApi } from '../services/api';
import { FiCheckCircle, FiXCircle, FiMail } from 'react-icons/fi';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('No verification token provided.');
        return;
      }

      try {
        const response = await authApi.verifyEmail(token);
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'Email verified successfully!');
          // Redirect to login after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Failed to verify email. The link may have expired.');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <Container className="mt-5 mb-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card className="shadow-lg border-0">
            <Card.Header className="text-center py-4">
              <div className="mb-3">
                {status === 'loading' && (
                  <div className="loading-spinner" style={{ margin: '0 auto', width: '48px', height: '48px' }}></div>
                )}
                {status === 'success' && (
                  <FiCheckCircle style={{ fontSize: '3rem', color: 'white' }} />
                )}
                {status === 'error' && (
                  <FiXCircle style={{ fontSize: '3rem', color: 'white' }} />
                )}
                {status === 'loading' && (
                  <FiMail style={{ fontSize: '3rem', color: 'white' }} />
                )}
              </div>
              <Card.Title className="mb-0" style={{ color: 'white', fontSize: '1.75rem' }}>
                {status === 'loading' && 'Verifying Email...'}
                {status === 'success' && 'Email Verified!'}
                {status === 'error' && 'Verification Failed'}
              </Card.Title>
            </Card.Header>
            <Card.Body className="p-4 text-center">
              {status === 'loading' && (
                <p className="mb-0">Please wait while we verify your email address...</p>
              )}
              
              {status === 'success' && (
                <>
                  <Alert variant="success" className="mb-4">
                    {message}
                  </Alert>
                  <p className="text-muted mb-4">Redirecting to login page...</p>
                  <Button variant="primary" onClick={() => navigate('/login')}>
                    Go to Login
                  </Button>
                </>
              )}

              {status === 'error' && (
                <>
                  <Alert variant="danger" className="mb-4">
                    {message}
                  </Alert>
                  <p className="text-muted mb-3">
                    You can request a new verification email from the login page.
                  </p>
                  <Link to="/login">
                    <Button variant="primary">Go to Login</Button>
                  </Link>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyEmailPage;
